<mat-card class="mat-elevation-z0 questions-card" [ngClass]="{'candidate-answers-view': showAnswers}">
  <mat-tab-group dynamicHeight mat-stretch-tabs class="questions-tab-group"
    *ngIf="hasAnyQuestions(); else noDataTemplate" (selectedIndexChange)="selectedTabChange($event)">

    <mat-tab label="Multiple Choice Questions" *ngIf="previewQuestions?.multipleChoiceQuestionList?.length > 0">
      <div class="mcqs-preview">
        <ng-container *ngIf="previewQuestions?.multipleChoiceQuestionList?.length">
          <mat-card *ngFor="let question of previewQuestions?.multipleChoiceQuestionList; let index = index"
            class="question-card mat-elevation-z1"
            [ngClass]="{'unanswered-card': !question.userAnswer, 'correct-card': question.correctAnswer && showAnswers, 'incorrect-card': !question.correctAnswer && showAnswers}">
            <div class="question-header">
              <span class="question-title">Question {{ (index + 1) }}
                <mat-chip *ngIf="!question.userAnswer" color="accent" selected class="unanswered-chip"
                  matTooltip="You did not answer this question">
                  <!-- <mat-icon style="font-size: 1.1em; vertical-align: middle;">info</mat-icon> -->
                  <span class="unanswered-chip-text">Unanswered</span>
                </mat-chip>
              </span>
              <mat-chip *ngIf="showAnswers" [color]="question.correctAnswer ? 'primary' : 'warn'"
                [ngClass]="{'correct-chip': question.correctAnswer, 'incorrect-chip': !question.correctAnswer}"
                selected>
                {{ question.correctAnswer ? 'Correct' : 'Incorrect' }}
              </mat-chip>
            </div>
            <div class="question-text" [innerHTML]="formatQuestionText(question.questionText)"></div>
            <mat-radio-group [value]="question.userAnswer" disabled>
              <mat-radio-button *ngFor="let option of question.options" [value]="option" class="option-radio" [ngClass]="{
                  'correct-option': (question.answer === option && showAnswers),
                  'selected-incorrect-option': (question.userAnswer === option && !question.correctAnswer && showAnswers)
                }">
                <span class="option-content">
                  <span [innerHTML]="formatQuestionText(option)"></span>
                  <mat-icon *ngIf="question.answer === option && showAnswers" color="primary"
                    class="correct-icon">check_circle</mat-icon>
                  <mat-icon *ngIf="question.userAnswer === option && !question.correctAnswer && showAnswers"
                    color="warn" class="wrong-icon">cancel</mat-icon>
                </span>
              </mat-radio-button>
            </mat-radio-group>
          </mat-card>
        </ng-container>
      </div>
    </mat-tab>

    <mat-tab label="Open Ended Questions" *ngIf="previewQuestions?.openEndedQuestionList?.length > 0">
      <div class="oeqs-preview">
        <ng-container *ngIf="previewQuestions?.openEndedQuestionList?.length">
          <mat-card *ngFor="let question of previewQuestions?.openEndedQuestionList; let index = index"
            class="question-card mat-elevation-z1"
            [ngClass]="{'unanswered-card': !question.userAnswer, 'correct-card': question.userAnswer && showAnswers}">
            <div class="question-header">
              <span class="question-title">Question {{ (index + 1) }}
                <mat-chip *ngIf="!question.userAnswer" selected class="unanswered-chip"
                  matTooltip="You did not answer this question">
                  <!-- <mat-icon style="font-size: 1.2em; vertical-align: middle;">info</mat-icon> -->
                  <span class="unanswered-chip-text">Unanswered</span>
                </mat-chip>
              </span>
              <mat-chip *ngIf="showAnswers" color="accent" selected>
                Open Ended
              </mat-chip>
            </div>
            <div class="question-text" [innerHTML]="formatQuestionText(question.questionText)"></div>
            <div class="answer-label">Answer:</div>
            <div class="open-answer" *ngIf="question.userAnswer; else noAnswer"
              [innerHTML]="formatQuestionText(question.userAnswer)"></div>
            <ng-template #noAnswer><span class="no-ans">Not Answered</span></ng-template>

            <!-- AI Evaluation Section -->
            <div class="ai-evaluation-container animate-fade-in-up" *ngIf="question.isAiEvaluated && showAnswers">
              <div class="ai-eval-header">
                <div class="ai-badge">
                  <mat-icon>psychology</mat-icon>
                  <span>AI EVALUATION</span>
                </div>
                <div class="ai-score-pill" [ngClass]="getScoreClass(question.aiScore)">
                  <span class="score-num">{{question.aiScore}}</span>
                  <span class="score-total">/10</span>
                </div>
              </div>
              <div class="ai-feedback-content">
                <p class="feedback-text">{{question.aiFeedback}}</p>
              </div>
            </div>
          </mat-card>
        </ng-container>
      </div>
    </mat-tab>

    <mat-tab label="Coding Questions" *ngIf="previewQuestions?.codingQuestionsList?.length > 0">
      <div class="cq-preview">
        <ng-container *ngIf="previewQuestions?.codingQuestionsList?.length">
          <mat-card *ngFor="let question of previewQuestions?.codingQuestionsList; let cqIdx = index"
            class="question-card mat-elevation-z1"
            [ngClass]="{'unanswered-card': !question.userAnswer, 'correct-card': question.userAnswer && showAnswers}">
            <div class="question-header">
              <span class="question-title">Question {{ (cqIdx + 1) }}
                <mat-chip *ngIf="!question.userAnswer" selected class="unanswered-chip"
                  matTooltip="You did not answer this question">
                  <!-- <mat-icon style="font-size: 1.2em; vertical-align: middle;">info</mat-icon> -->
                  <span class="unanswered-chip-text">Unanswered</span>
                </mat-chip>
              </span>
              <mat-chip color="accent" selected>Coding</mat-chip>
            </div>
            <div class="question-text" [innerHTML]="formatQuestionText(question.questionText)"></div>
            <div class="answer-label">Answer:</div>
            <div class="app-ace-editor" id="preview-ace-editor-{{cqIdx}}" #previewCodingQuestionEditor></div>
            <button mat-stroked-button color="primary" (click)="copyCode(cqIdx)">
              <mat-icon>content_copy</mat-icon> Copy Code
            </button>
            <div class="answer-label">Output:</div>
            <div class="test-output">{{ question.answerSignature?.answer?.run_results?.output ??
              question.answerSignature?.answer?.run_results?.errorMessage }}</div>
          </mat-card>
        </ng-container>
      </div>
    </mat-tab>

  </mat-tab-group>
</mat-card>
<ng-template #noDataTemplate>
  <mat-card class="question-card mat-elevation-z0">No questions for assessment</mat-card>
</ng-template>